import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import SelectMenu from "../common/forms/selectmenu";
import Exbondviewtable from './exbondviewtable'
import { Search } from 'lucide-react';
import { MdLockReset } from 'react-icons/md';
import Exbondheading from './exbondheading';
import { refreshAccessToken, API_CONFIG, getHeaders } from "../../config/api";
import DateLabelInput from '../common/forms/DateLabelInput';
import { useAuth } from "../../context/AuthContext"; // Auth context

export default function Exbondview() {
    const location = useLocation();
    const [searchTerm, setSearchTerm] = useState("");
    const [customers, setCustomers] = useState([]);
    const [loadingCustomers, setLoadingCustomers] = useState(false);
    const [bestartDate, setBeStartDate] = useState("");
    const [beendDate, setBeEndDate] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const { logout } = useAuth();

    useEffect(() => {
        if (location.state?.showToast) {
            toast.success(location.state.message);
            // Clear state so toast doesn't reappear on refresh
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);
    // Reset filters
    const resetFilters = () => {
        setSearchTerm("");
        setBeStartDate("");
        setBeEndDate("");
        setSelectedCustomer("");
    };
    const fetchCustomers = useCallback(async () => {
        setLoadingCustomers(true);

        try {
            const url = new URL(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.CUSTOMERS.GET_ALL}`);
            url.searchParams.append("mode", "edit");

            let response = await fetch(url.toString(), {
                method: "GET",
                headers: getHeaders(true),
            });

            if (response.status === 401) {
                console.warn("Access token expired. Attempting refresh...");
                const newToken = await refreshAccessToken();

                if (newToken) {
                    response = await fetch(url.toString(), {
                        method: "GET",
                        headers: getHeaders(true),
                    });
                } else {
                    console.error("Refresh token failed. Logging out...");
                    logout();
                    return;
                }
            }

            const result = await response.json();

            if (result.status === 200 && Array.isArray(result.data)) {
                setCustomers(
                    result.data.map((customer) => ({
                        label: customer.name,
                        value: customer.name,
                    }))
                );
            } else {
                setCustomers([]);
            }
        } catch (error) {
            console.error("Error fetching customers:", error);
            setCustomers([]);
        } finally {
            setLoadingCustomers(false);
        }
    }, [logout]); // 👈 EMPTY array makes the function stable

    useEffect(() => {
        fetchCustomers();
    }, [fetchCustomers]);
    const formatLabel = (value) => {
        return value
            ? value
                .toLowerCase()
                .split(",")
                .map(part =>
                    part
                        .trim()
                        .split(" ")
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(" ")
                )
                .join(", ")
            : "";
    };
    return (
        <>
            <Exbondheading />
            <div className="p-2 px-1">
                <div className="flex flex-wrap justify-center items-center gap-4 mb-4">
                    {/* Search Input */}
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
                        <input
                            type="text"
                            placeholder="Search by BI No. or BE No. or Ex No."
                            className="h-11 pl-10 pr-3 py-2 border rounded text-sm focus:outline-none focus:ring-2 focus:ring-black"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className='w-36'>
                        <div className='w-36'>
                            <SelectMenu
                                label="Customer"
                                name="customer"
                                options={customers.map(opt => ({
                                    ...opt,
                                    label: formatLabel(opt.label)
                                }))}
                                loading={loadingCustomers}
                                value={selectedCustomer}           // FIXED
                                onChange={(val) => setSelectedCustomer(val)}   // FIXED
                                searchable
                                usePortal
                            />
                        </div>

                    </div>
                    <div className='w-36'>
                        <DateLabelInput
                            label="BE Start Date"
                            type="date"
                            value={bestartDate}
                            onChange={(e) => setBeStartDate(e.target.value)}
                        />
                    </div>
                    <div className='w-36'>
                        <DateLabelInput
                            label="BE End Date"
                            type="date"
                            value={beendDate}
                            onChange={(e) => setBeEndDate(e.target.value)}
                        />
                    </div>

                    {/* Reset button */}
                    {(searchTerm || bestartDate || beendDate || selectedCustomer) && (
                        <button
                            onClick={resetFilters}
                            className="flex items-center justify-center h-11 w-11"
                            title="Reset Filters"
                        >
                            <MdLockReset size={20} />
                        </button>
                    )}
                </div>
                <Exbondviewtable
                    searchTerm={searchTerm}
                    bestartDate={bestartDate}
                    beendDate={beendDate}
                    selectedCustomer={selectedCustomer}   // FIXED
                />
            </div>
        </>
    )
}
